export default __webpack_public_path__ + "static/media/amanita2.d3d68851.png";